import { apiRequest } from "../../services/apiService";
import {
  GET_LOGIN_USER_FAIL, GET_LOGIN_USER_SUCCESS, GET_LOGIN_USER_REQUEST
} from "../constant";

export const userDetailHeader = () => {
  return async (dispatch) => {
    dispatch({ type: GET_LOGIN_USER_REQUEST });
    const { response } = await apiRequest({
      method: "POST",
      url: `/users/getUserPer`,
    });
    if (response?.data?.statusCode === 200 && Array.isArray(response.data.data)) {
      dispatch({ type: GET_LOGIN_USER_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: GET_LOGIN_USER_FAIL });
    }
  };
};
